import stretchDollar from '../assets/img/partners/stretch_dollar.jpg';

export const partnersMap = new Map<string, string>([['stretchdollar', 'StretchDollar']]);

export const partnerLogoMap = new Map<string, string>([['stretchdollar', stretchDollar]]);

export const hasValidPartnership = (partnership: string) => partnersMap.has(partnership);
